// app/providers.js
"use client";

import { c as _c } from "react/compiler-runtime";
import "posthog-js/dist/exception-autocapture";
import { PostHogProvider } from "posthog-js/react";
import { useEffect } from "react";
import { analyticsClient, startPostHogWhenAllowed, stopPostHogNow } from "@/lib/posthog-browser";
import { onTrackingConsentWithdrawal, useTrackingConsent } from "@/hooks/useTrackingConsent";

// PostHog runs only with analytics consent from the cookie banner; without it
// the browser sends nothing to PostHog (src/lib/posthog-browser.ts).
export { analyticsClient };
export function CSPostHogProvider(t0) {
  const $ = _c(8);
  const {
    children,
    bootstrapData
  } = t0;
  const {
    analytics: hasAnalyticsConsent
  } = useTrackingConsent();
  let t1;
  if ($[0] !== bootstrapData) {
    t1 = () => startPostHogWhenAllowed(bootstrapData);
    $[0] = bootstrapData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== bootstrapData || $[3] !== hasAnalyticsConsent) {
    t2 = [bootstrapData, hasAnalyticsConsent];
    $[2] = bootstrapData;
    $[3] = hasAnalyticsConsent;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(_temp, t3);
  let t4;
  if ($[6] !== children) {
    t4 = <PostHogProvider client={analyticsClient}>{children}</PostHogProvider>;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp() {
  return onTrackingConsentWithdrawal(stopPostHogNow);
}